// extracted by mini-css-extract-plugin
export var circle = "_w-2";
export var icon = "_w-a";
export var iconHighlight = "_w-0";
export var lg = "_w-8";
export var md = "_w-7";
export var outline = "_w-4";
export var sm = "_w-6";
export var square = "_w-1";
export var xl = "_w-9";
export var xs = "_w-5";
export var xxs = "_w-3";